import React, { createContext, useReducer } from 'react';
import US from '../data/localization/en-US.json';
import CA from '../data/localization/en-CA.json';

const initialState = { localization: US };
const LocalizationContext = createContext(initialState);
const { Provider } = LocalizationContext;
const localizationMap = {
  US,
  CA,
};

const LocalizationProvider = ({ children }) => {
  const [localizationState, localizationDispatch] = useReducer(
    (contextState, action) => {
      const typeOptions = {
        SET_LOCALIZATION: {
          localization: localizationMap[action.localization] ?? US,
        },
      };

      if (typeOptions[action.type]) {
        return typeOptions[action.type];
      }

      throw new Error();
    },
    initialState,
  );
  return (
    <Provider value={{ localizationState, localizationDispatch }}>
      {children}
    </Provider>
  );
};

export { LocalizationContext, LocalizationProvider };
